export default __webpack_public_path__ + "static/DOTSafetySeal-d287f908f7216be8f7c463ba5c6385c4.png";